import ParlorPromotion50Modal from "@/components/common/Modal/ParlorPromotion50Modal";

import { useOverlay } from "@toss/use-overlay";
import { OverlayModal } from "goi_common";
import { useRouter } from "next/router";
import { useEffect } from "react";

// export const useOpenParlorPromotion50Modal = ({
//   sido,
//   sigungu,
// }: {
//   sido?: string;
//   sigungu?: string;
// }) => {

export const useOpenParlorPromotion50Modal = () => {
  const router = useRouter();
  const { id } = router.query;

  useEffect(() => {
    if (id === "50") {
      onOpenRevisitModal();
    }
  }, [id]);

  const overlay = useOverlay();

  const onOpenRevisitModal = () => {
    overlay.open(({ isOpen, close: onClose }) => {
      return (
        <OverlayModal
          onClose={onClose}
          isOpen={isOpen}
          closeOnOverlayClick
          modalContentStyle={{
            minWidth: "280px",
            overflow: "scroll",
          }}
          overlayModalContent={<ParlorPromotion50Modal onClose={onClose} path={"parlor"} />}
        />
      );
    });
  };
  return { onOpenRevisitModal };
};
